// When all four quadrants (or leadership styles) have the same score, rank them
// in a fixed clockwise order instead of whatever order the data arrived in.
export const STARTER_CLOCKWISE = ["strength", "heart", "soul", "mind"];
export const LEADERSHIP_CLOCKWISE = ["performance", "collaborative", "visionary", "strategic"];

const ALIASES = {
  str: "strength",
  col: "collaborative",
  collab: "collaborative",
  vis: "visionary",
  strat: "strategic",
  per: "performance",
  perf: "performance",
};

export const normalizeQuadrantName = (name) => {
  const key = String(name ?? "").trim().toLowerCase();
  return ALIASES[key] || key;
};

const clockwiseOrderFor = (names) => {
  const keys = names.map(normalizeQuadrantName);
  if (keys.every((k) => STARTER_CLOCKWISE.includes(k))) return STARTER_CLOCKWISE;
  if (keys.every((k) => LEADERSHIP_CLOCKWISE.includes(k))) return LEADERSHIP_CLOCKWISE;
  return null;
};

// True when exactly four scores are present and all match at 2 decimals (as displayed).
// Missing scores (data not loaded yet) never count as a tie.
export const isFullTie = (values) => {
  if (!Array.isArray(values) || values.length !== 4) return false;
  const numbers = values.map((v) => (v === null || v === undefined || v === "" ? NaN : Number(v)));
  if (numbers.some((n) => !Number.isFinite(n))) return false;
  const rounded = numbers.map((n) => Number(n.toFixed(2)));
  return rounded.every((v) => v === rounded[0]);
};

// Returns the items in clockwise order when all four are tied; otherwise returns them unchanged.
export const applyFullTieOrder = (items, getName = (item) => item?.name, getValue = (item) => item?.value) => {
  if (!Array.isArray(items) || !isFullTie(items.map(getValue))) return items;
  const order = clockwiseOrderFor(items.map(getName));
  if (!order) return items;
  return [...items].sort(
    (a, b) => order.indexOf(normalizeQuadrantName(getName(a))) - order.indexOf(normalizeQuadrantName(getName(b)))
  );
};
